// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cu-2";
export var aiChatCartContainerExit = "_cu-4";
export var aiChatContainerLarge = "_cu-0";
export var aiChatContainerSmall = "_cu-1";
export var aiChatIcon = "_cu-6";
export var slideInFromRight = "_cu-3";
export var slideOutToRight = "_cu-5";